export default "__VITE_ASSET__BfhaPCKb__";